// cardData.js
const cardData = [
  {
    title: "Informal Farewell 2026",
    imageSrc: "file:///Users/neela/SoCE-25/SoCE-23/public/Gallery/Informal%20poster.jpeg",
    description:
      "A grand celebration for the Graduating Batch of 2026 at the Outreach Auditorium on April 17. Let’s celebrate a remarkable college life and new beginnings ahead!",
    slides: [
      "/Gallery/Informal poster.jpeg",
    ],
  }, // <--- Ensure this comma exists!
  {
    title: "Freshers 2k25",
    imageSrc: "/Gallery/Headers/Freshers25post.png",
    description:
      "We were delighted to host Freshers ’25 for first-year UG and PG Civil Engineering students, marking another joyful milestone in warmly welcoming new members to our department",
    slides: [
      "/Gallery/Freshers-25/01.jpg",
      "/Gallery/Freshers-25/02.jpg",
      "/Gallery/Freshers-25/03.jpg",
      "/Gallery/Freshers-25/04.jpg",
      "/Gallery/Freshers-25/05.jpg",
      "/Gallery/Freshers-25/06.jpg",
    ],
  },
  {
    title: "Alumni Meet'25",
    imageSrc: "/Gallery/Headers/Parwa-25.png",
    description:
      "We proudly organized Parwa Alumni Meet'25, bringing former students together to reconnect, share experiences, and celebrate the lasting bond between past and present Civil Engineering members.",
    slides: [
      "/Gallery/Parwa-25/01.jpg",
      "/Gallery/Parwa-25/02.jpg",
      "/Gallery/Parwa-25/03.jpg",
      "/Gallery/Parwa-25/04.jpg",
      "/Gallery/Parwa-25/05.jpg",
      "/Gallery/Parwa-25/06.jpg",
      "/Gallery/Parwa-25/07.jpg",
      "/Gallery/Parwa-25/08.jpg",
    ],
  },
  // ... the rest of your cards continue here
];

export default cardData;